import { createFileRoute } from "@tanstack/react-router";

import { DevPatientManagementPage } from "@/uiKit/pages/DevPatientManagementPage.tsx";

export const Route = createFileRoute("/_practitioner/patients/$patientId/patient-management")({
  component: DevPatientManagementPage,
});
